// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3DfXG","containerTablet":"styles_containerTablet__3zoBk","containerDesktop":"styles_containerDesktop__1wWcM"};